<template>
  <div class="tab-download">
    <p class="mb-5">
      The five FIRESAFE II reports that can be downloaded below cover the
      following topics:
    </p>
    <div class="download-box clearfix">
      <div class="download-box-left">
        <a
          class="label"
          href="http://emsa.europa.eu/firesafe/download/5483/2904/23.html"
          target="_blank"
          >WP1</a
        >
        <a
          class="download-link"
          href="http://emsa.europa.eu/firesafe/download/5483/2904/23.html"
          target="_blank"
        >
          <img src="assets/img/icona_download.png" />
          <span>download</span>
        </a>
      </div>
      <div class="download-box-right">
        <p>
          <span class="float-left mr-1">WP1 </span>
          Final Report, this report presents a Formal Safety Assessment on
          <strong>detection</strong> and on <strong> decision</strong> of
          extinguishing system activation following a ro-ro space fire incident
          on any ro-ro passenger ship
        </p>
      </div>
    </div>
    <div class="download-box clearfix">
      <div class="download-box-left">
        <a
          class="label"
          href="http://emsa.europa.eu/firesafe/download/5485/2904/23.html"
          target="_blank"
          >WP2</a
        >
        <a
          class="download-link"
          href="http://emsa.europa.eu/firesafe/download/5485/2904/23.html"
          target="_blank"
        >
          <img src="assets/img/icona_download.png" />
          <span>download</span>
        </a>
      </div>
      <div class="download-box-right">
        <p>
          <span class="float-left mr-1">WP2 </span>
          Final Report, this report presents a Formal Safety Assessment on
          <strong>containment</strong> and on
          <strong>evacuation</strong> following a ro-ro space fire incident on
          any ro-ro passenger ship.
        </p>
      </div>
    </div>
    <div class="download-box clearfix">
      <div class="download-box-left">
        <a
          class="label"
          href="http://emsa.europa.eu/firesafe/download/5484/2904/23.html"
          target="_blank"
          >WP2</a
        >
        <a
          class="download-link"
          href="http://emsa.europa.eu/firesafe/download/5484/2904/23.html"
          target="_blank"
        >
          <img src="assets/img/icona_download.png" />
          <span>download</span>
        </a>
      </div>
      <div class="download-box-right">
        <p>
          <span class="float-left mr-1">WP2 </span>
          Combined Assessment, this report presents the results of the
          <strong>combined assessment</strong> of cost effectiveness based on
          the results from the different parts previously considered separately
          in FIRESAFE and FIRESAFE II.
        </p>
      </div>
    </div>
    <div class="download-box clearfix">
      <div class="download-box-left">
        <a
          class="label"
          href="http://emsa.europa.eu/firesafe/download/5486/2904/23.html"
          target="_blank"
          >WP3</a
        >
        <a
          class="download-link"
          href="http://emsa.europa.eu/firesafe/download/5486/2904/23.html"
          target="_blank"
        >
          <img src="assets/img/icona_download.png" />
          <span>download</span>
        </a>
      </div>
      <div class="download-box-right">
        <p>
          <span class="float-left mr-1">WP3 </span>
          Final Report, this report presents a review of potential commercially
          available <strong>alternative fire extinguishing systems</strong> and
          their expected performance efficiency, water consumption and estimated
          installation costs. Additionally,
          <strong>large-scale fire tests</strong> were performed for selected
          systems.
        </p>
      </div>
    </div>
    <div class="download-box clearfix">
      <div class="download-box-left">
        <a
          class="label"
          href="http://emsa.europa.eu/firesafe/download/5487/2904/23.html"
          target="_blank"
          >WP4</a
        >
        <a
          class="download-link"
          href="http://emsa.europa.eu/firesafe/download/5487/2904/23.html"
          target="_blank"
        >
          <img src="assets/img/icona_download.png" />
          <span>download</span>
        </a>
      </div>
      <div class="download-box-right">
        <p>
          <span class="float-left mr-1">WP4 </span>
          Final Report, This report presents available and emerging
          <strong>fire detection technologies</strong> for use in open ro-ro
          spaces and on weather decks. Fibre optic linear heat detection (open
          ro-ro spaces) and thermal imaging camera (weather deck) were fire
          <strong>tested onboard</strong> a test vessel.
        </p>
      </div>
    </div>
    <div class="notes">
      <strong>NOTE</strong>
      <ul>
        <li>
          Within this infographic the main results of the Combined Assessment
          (WP2) are presented.
        </li>
        <li>
          It should be noted that the report of WP1 also includes a list of
          items in A1.9 (p. 178) which could be used as best practices.
          Similarly four of the RCOs were not included in this infographic as
          they were all found to be extremely cost efficient for both
          Newbuildings and Existing Ships (Training for awareness, only crew
          connections, efficient activation routines, fresh water activation)
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "DownloadReports",
  mounted: function() {
    this.$store.commit("setPageClass", "download-reports");
    this.$store.commit("setFiresafeNumber", 0);
  }
};
</script>

<style scoped></style>
